import { UserAccessLevel, UserRole } from '../../types/user';

export function getRoleString(accessLevel: UserAccessLevel | string | number) {
  switch (parseInt(String(accessLevel), 10)) {
    case UserAccessLevel.SUPER_ADMIN:
      return UserRole.SUPER_ADMIN;
    case UserAccessLevel.ORGANIZATION_ADMIN:
      return UserRole.ORGANIZATION_ADMIN;
    case UserAccessLevel.DEVICE_GROUP_ADMIN:
      return UserRole.DEVICE_GROUP_ADMIN;
    case UserAccessLevel.REGULAR_USER:
      return UserRole.REGULAR_USER;
    case UserAccessLevel.ORGANIZATION_VIEWER:
      return UserRole.ORGANIZATION_VIEWER;
    default:
      return 'Not Authorized';
  }
}
